import { CuratedItemVariation } from "~types/types";

export function shouldShowByline(
    variation?: CuratedItemVariation,
    isOpinionStory?: boolean
) {
    return (
        variation !== CuratedItemVariation.FeaturedWithoutByline &&
        (isOpinionStory || variation === CuratedItemVariation.Featured)
    );
}
